import React from 'react';
import { useLang } from './LangContext';

const EmailLink = () => (
  <a href="mailto:pomodoro.flow.yt@gmail.com" className="info-link">
    pomodoro.flow.yt@gmail.com
  </a>
);

const ImprintDE = () => (
  <div className="info-page-shell">
    <div className="info-page">
      <section className="content-card info-card info-hero-card">
        <p className="eyebrow">Pomodoro Flow</p>
        <h1>Impressum</h1>
        <p className="lead info-intro">Pflichtangaben und Ansprechpartner für dieses Angebot.</p>
      </section>

      <div className="info-page-stack">
        <section className="content-card info-card">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            Tobias Mai
            <br />
            Lindenstockstraße 31A
            <br />
            51647 Gummersbach
            <br />
            Deutschland
          </p>
        </section>

        <section className="content-card info-card">
          <h2>Kontakt</h2>
          <p>
            E-Mail: <EmailLink />
          </p>
        </section>

        <section className="content-card info-card">
          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>Tobias Mai</p>
        </section>

        <section className="content-card info-card">
          <h2>Haftungsausschluss</h2>
          <p>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
            Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          </p>
        </section>
      </div>
    </div>
  </div>
);

const ImprintEN = () => (
  <div className="info-page-shell">
    <div className="info-page">
      <section className="content-card info-card info-hero-card">
        <p className="eyebrow">Pomodoro Flow</p>
        <h1>Imprint</h1>
        <p className="lead info-intro">Required site ownership and contact details for this service.</p>
      </section>

      <div className="info-page-stack">
        <section className="content-card info-card">
          <h2>According to § 5 TMG</h2>
          <p>
            Tobias Mai
            <br />
            Lindenstockstraße 31A
            <br />
            51647 Gummersbach
            <br />
            Germany
          </p>
        </section>

        <section className="content-card info-card">
          <h2>Contact</h2>
          <p>
            Email: <EmailLink />
          </p>
        </section>

        <section className="content-card info-card">
          <h2>Responsible for content (§ 7 para. 1 TMG)</h2>
          <p>Tobias Mai</p>
        </section>

        <section className="content-card info-card">
          <h2>Limitation of liability</h2>
          <p>We are not liable for the contents of external links. The operators of linked pages are solely responsible for their content.</p>
        </section>
      </div>
    </div>
  </div>
);

const Imprint = () => {
  const { lang } = useLang();
  return lang === 'de' ? <ImprintDE /> : <ImprintEN />;
};

export default Imprint;
